import React, { createContext, useContext, useState, ReactNode } from 'react';
import { DrawRequestMessageModel } from '@models/drawRequests/DrawRequestMessageModel';

interface DrawRequestMessageContextType {
  pendingMessages: DrawRequestMessageModel[];
  addMessage: (message: DrawRequestMessageModel) => void;
  removeMessage: (index: number) => void;
  clearMessages: () => void;
  setPendingMessages: (messages: DrawRequestMessageModel[]) => void;
}

const DrawRequestMessageContext = createContext<
  DrawRequestMessageContextType | undefined
>(undefined);

export const useDrawRequestMessages = () => {
  const context = useContext(DrawRequestMessageContext);
  if (!context) {
    throw new Error(
      'useDrawRequestMessages must be used within DrawRequestMessageProvider'
    );
  }
  return context;
};

interface DrawRequestMessageProviderProps {
  children: ReactNode;
}

export const DrawRequestMessageProvider: React.FC<
  DrawRequestMessageProviderProps
> = ({ children }) => {
  const [pendingMessages, setPendingMessages] = useState<
    DrawRequestMessageModel[]
  >([]);

  const addMessage = (message: DrawRequestMessageModel) => {
    setPendingMessages(prev => [...prev, message]);
  };

  const removeMessage = (index: number) => {
    setPendingMessages(prev => prev.filter((_, i) => i !== index));
  };

  const clearMessages = () => {
    setPendingMessages([]);
  };

  return (
    <DrawRequestMessageContext.Provider
      value={{
        pendingMessages,
        addMessage,
        removeMessage,
        clearMessages,
        setPendingMessages,
      }}
    >
      {children}
    </DrawRequestMessageContext.Provider>
  );
};
